import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-disabled mb-4 mt-2" }, "In a hybrid application, individual applications can be toggled per-user. By default, all applications are toggled on.", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-disabled mb-4" }, "Configure application attributes for this user", -1)
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_8 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_9 = { class: "d-flex" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-disabled" }, "In a hybrid application, individual applications can be toggled per-user. By default, all applications are toggled on.", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-disabled mb-4" }, "Configure application attributes for this user", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, {
      class: "pt-2 mx-4",
      justify: "space-between",
      align: "center",
      dense: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              align: "center",
              dense: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { dense: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "4",
                          md: "auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_dialog, {
                              width: "500",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetDialog()))
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps(props, {
                                  size: "small",
                                  width: "230",
                                  variant: "tonal",
                                  color: "primary",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mapConfig(_ctx.currentApplication)))
                                }), {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      start: "",
                                      icon: "mdi-account-plus"
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.mdAndUp ? 'Add application user' : 'Add'), 1)
                                  ]),
                                  _: 2
                                }, 1040)
                              ]),
                              default: _withCtx(({ isActive }) => [
                                _createVNode(_component_v_card, null, {
                                  title: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      justify: "space-between"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "auto" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Add application users ")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "auto" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn, {
                                              size: "small",
                                              color: "primary",
                                              variant: "plain",
                                              onClick: _ctx.addUserRow
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_icon, {
                                                  start: "",
                                                  icon: "mdi-plus-circle"
                                                }),
                                                _createTextVNode(" Add ")
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "12" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, { cols: "12" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_1
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { cols: "12" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list, null, {
                                                          default: _withCtx(() => [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersToAdd, (user) => {
                                                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                                                key: user.email,
                                                                rounded: "",
                                                                class: "my-2 px-0"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_expansion_panels, { "model-value": "0" }, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_v_expansion_panel, { "bg-color": "rgba(0,0,0,0.05)" }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_v_expansion_panel_title, {
                                                                            class: "py-0 px-2",
                                                                            static: "",
                                                                            "hide-actions": ""
                                                                          }, {
                                                                            default: _withCtx(({ collapseIcon, expandIcon, expanded }) => [
                                                                              _createVNode(_component_v_row, {
                                                                                "no-gutters": "",
                                                                                justify: "space-between",
                                                                                align: "center"
                                                                              }, {
                                                                                default: _withCtx(() => [
                                                                                  _createVNode(_component_v_col, { cols: "1" }, {
                                                                                    default: _withCtx(() => [
                                                                                      expanded
                                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                                                                                            _createVNode(_component_v_icon, null, {
                                                                                              default: _withCtx(() => [
                                                                                                _createTextVNode(_toDisplayString(collapseIcon), 1)
                                                                                              ]),
                                                                                              _: 2
                                                                                            }, 1024)
                                                                                          ]))
                                                                                        : (_openBlock(), _createElementBlock("span", _hoisted_3, [
                                                                                            _createVNode(_component_v_icon, null, {
                                                                                              default: _withCtx(() => [
                                                                                                _createTextVNode(_toDisplayString(expandIcon), 1)
                                                                                              ]),
                                                                                              _: 2
                                                                                            }, 1024)
                                                                                          ]))
                                                                                    ]),
                                                                                    _: 2
                                                                                  }, 1024),
                                                                                  _createVNode(_component_v_col, { cols: "10" }, {
                                                                                    default: _withCtx(() => [
                                                                                      _createVNode(_component_v_list_item_title, null, {
                                                                                        default: _withCtx(() => [
                                                                                          _createTextVNode(_toDisplayString(_ctx.fullName(user.first_name, user.last_name)), 1)
                                                                                        ]),
                                                                                        _: 2
                                                                                      }, 1024),
                                                                                      _createVNode(_component_v_list_item_subtitle, null, {
                                                                                        default: _withCtx(() => [
                                                                                          _createTextVNode(_toDisplayString(user.email), 1)
                                                                                        ]),
                                                                                        _: 2
                                                                                      }, 1024)
                                                                                    ]),
                                                                                    _: 2
                                                                                  }, 1024),
                                                                                  _createVNode(_component_v_col, { cols: "1" }, {
                                                                                    default: _withCtx(() => [
                                                                                      _createVNode(_component_v_list_item_action, null, {
                                                                                        default: _withCtx(() => [
                                                                                          _createVNode(_component_v_btn, {
                                                                                            icon: "",
                                                                                            variant: "plain",
                                                                                            color: "primary",
                                                                                            size: "small",
                                                                                            onClick: ($event: any) => (_ctx.removeNewUser(user))
                                                                                          }, {
                                                                                            default: _withCtx(() => [
                                                                                              _createVNode(_component_v_icon, {
                                                                                                icon: "mdi-delete",
                                                                                                size: "large"
                                                                                              })
                                                                                            ]),
                                                                                            _: 2
                                                                                          }, 1032, ["onClick"])
                                                                                        ]),
                                                                                        _: 2
                                                                                      }, 1024)
                                                                                    ]),
                                                                                    _: 2
                                                                                  }, 1024)
                                                                                ]),
                                                                                _: 2
                                                                              }, 1024)
                                                                            ]),
                                                                            _: 2
                                                                          }, 1024),
                                                                          _createVNode(_component_v_expansion_panel_text, { class: "mt-1" }, {
                                                                            default: _withCtx(() => [
                                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationsForHybrid, (app) => {
                                                                                return (_openBlock(), _createBlock(_component_v_row, {
                                                                                  key: app.id
                                                                                }, {
                                                                                  default: _withCtx(() => [
                                                                                    _createVNode(_component_v_col, { cols: "12" }, {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(_component_v_row, {
                                                                                          "no-gutters": "",
                                                                                          justify: "space-between",
                                                                                          align: "center"
                                                                                        }, {
                                                                                          default: _withCtx(() => [
                                                                                            _createVNode(_component_v_col, null, {
                                                                                              default: _withCtx(() => [
                                                                                                _createVNode(_component_v_list_item_title, null, {
                                                                                                  default: _withCtx(() => [
                                                                                                    _createTextVNode(_toDisplayString(_ctx.currentApplication?.details?.applications?.find((a) => a.applicationId === app.id)?.tabName || app.name), 1)
                                                                                                  ]),
                                                                                                  _: 2
                                                                                                }, 1024),
                                                                                                _createVNode(_component_v_list_item_subtitle, null, {
                                                                                                  default: _withCtx(() => [
                                                                                                    _createTextVNode("Enabled for this user")
                                                                                                  ]),
                                                                                                  _: 1
                                                                                                })
                                                                                              ]),
                                                                                              _: 2
                                                                                            }, 1024),
                                                                                            _createVNode(_component_v_col, { cols: "2" }, {
                                                                                              default: _withCtx(() => [
                                                                                                app
                                                                                                  ? (_openBlock(), _createBlock(_component_v_switch, {
                                                                                                      key: 0,
                                                                                                      "hide-details": "",
                                                                                                      density: "compact",
                                                                                                      modelValue: _ctx.userApplicationsForHybrid[user.id][app.id],
                                                                                                      "onUpdate:modelValue": [
                                                                                                        ($event: any) => ((_ctx.userApplicationsForHybrid[user.id][app.id]) = $event),
                                                                                                        _cache[1] || (_cache[1] = ($event: any) => (_ctx.appConfigDirtied = true))
                                                                                                      ],
                                                                                                      color: "primary"
                                                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                                                                  : _createCommentVNode("", true)
                                                                                              ]),
                                                                                              _: 2
                                                                                            }, 1024)
                                                                                          ]),
                                                                                          _: 2
                                                                                        }, 1024)
                                                                                      ]),
                                                                                      _: 2
                                                                                    }, 1024),
                                                                                    (_ctx.applicationAttributes.length)
                                                                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                                                                          key: 0,
                                                                                          cols: "12"
                                                                                        }, {
                                                                                          default: _withCtx(() => [
                                                                                            _hoisted_4,
                                                                                            _createVNode(_component_v_row, { class: "ml-2" }, {
                                                                                              default: _withCtx(() => [
                                                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationAttributes, (attribute) => {
                                                                                                  return (_openBlock(), _createBlock(_component_v_col, {
                                                                                                    cols: "12",
                                                                                                    key: attribute.id
                                                                                                  }, {
                                                                                                    default: _withCtx(() => [
                                                                                                      _createVNode(_component_v_row, {
                                                                                                        "no-gutters": "",
                                                                                                        justify: "space-between"
                                                                                                      }, {
                                                                                                        default: _withCtx(() => [
                                                                                                          _createVNode(_component_v_col, null, {
                                                                                                            default: _withCtx(() => [
                                                                                                              _createVNode(_component_v_list_item_title, null, {
                                                                                                                default: _withCtx(() => [
                                                                                                                  _createTextVNode(_toDisplayString(attribute.name), 1)
                                                                                                                ]),
                                                                                                                _: 2
                                                                                                              }, 1024),
                                                                                                              _createVNode(_component_v_list_item_subtitle, null, {
                                                                                                                default: _withCtx(() => [
                                                                                                                  _createTextVNode(_toDisplayString(attribute.description), 1)
                                                                                                                ]),
                                                                                                                _: 2
                                                                                                              }, 1024)
                                                                                                            ]),
                                                                                                            _: 2
                                                                                                          }, 1024),
                                                                                                          _createVNode(_component_v_col, { cols: "2" }, {
                                                                                                            default: _withCtx(() => [
                                                                                                              (attribute.type === 'boolean')
                                                                                                                ? (_openBlock(), _createBlock(_component_v_switch, {
                                                                                                                    key: 0,
                                                                                                                    "hide-details": "",
                                                                                                                    density: "compact",
                                                                                                                    modelValue: user.attributes[attribute.id].value,
                                                                                                                    "onUpdate:modelValue": [
                                                                                                                      ($event: any) => ((user.attributes[attribute.id].value) = $event),
                                                                                                                      _cache[2] || (_cache[2] = ($event: any) => (_ctx.appConfigDirtied = true))
                                                                                                                    ],
                                                                                                                    color: "primary"
                                                                                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                                                                                : _createCommentVNode("", true)
                                                                                                            ]),
                                                                                                            _: 2
                                                                                                          }, 1024)
                                                                                                        ]),
                                                                                                        _: 2
                                                                                                      }, 1024)
                                                                                                    ]),
                                                                                                    _: 2
                                                                                                  }, 1024))
                                                                                                }), 128))
                                                                                              ]),
                                                                                              _: 2
                                                                                            }, 1024)
                                                                                          ]),
                                                                                          _: 2
                                                                                        }, 1024))
                                                                                      : _createCommentVNode("", true)
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1024))
                                                                              }), 128))
                                                                            ]),
                                                                            _: 2
                                                                          }, 1024)
                                                                        ]),
                                                                        _: 2
                                                                      }, 1024)
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024)
                                                                ]),
                                                                _: 2
                                                              }, 1024))
                                                            }), 128)),
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newUsers, (user) => {
                                                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                                                class: "mb-1 px-0 pt-0",
                                                                key: user.email
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_combobox, {
                                                                    class: "app-combobox",
                                                                    clearable: "",
                                                                    items: _ctx.filteredTenantUsers,
                                                                    "item-title": "name",
                                                                    "hide-details": "",
                                                                    density: "comfortable",
                                                                    placeholder: "Search users",
                                                                    "return-object": "",
                                                                    "menu-props": { maxWidth: 452 }
                                                                  }, {
                                                                    selection: _withCtx(({ item }) => [
                                                                      _createElementVNode("div", _hoisted_5, [
                                                                        _createVNode(_component_v_list_item_title, null, {
                                                                          default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(_ctx.fullName(item.raw.first_name, item.raw.last_name)), 1)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1024),
                                                                        _createVNode(_component_v_list_item_subtitle, null, {
                                                                          default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(item.raw.email), 1)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1024)
                                                                      ])
                                                                    ]),
                                                                    item: _withCtx(({ item }) => [
                                                                      _createElementVNode("div", _hoisted_6, [
                                                                        _createVNode(_component_v_list_item, {
                                                                          onClick: ($event: any) => {_ctx.newUser = item.raw; _ctx.addApplicationAccess()}
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createVNode(_component_v_list_item_title, null, {
                                                                              default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(_ctx.fullName(item.raw.first_name, item.raw.last_name)), 1)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024),
                                                                            _createVNode(_component_v_list_item_subtitle, null, {
                                                                              default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(item.raw.email), 1)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1032, ["onClick"])
                                                                      ])
                                                                    ]),
                                                                    _: 1
                                                                  }, 8, ["items"])
                                                                ]),
                                                                _: 2
                                                              }, 1024))
                                                            }), 128))
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_card_actions, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                          loading: _ctx.loading,
                                          disabled: !_ctx.usersToAdd.length || _ctx.loading,
                                          color: "primary",
                                          onClick: ($event: any) => {_ctx.saveUsers(); isActive.value = false;}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Add users ")
                                          ]),
                                          _: 2
                                        }, 1032, ["loading", "disabled", "onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "4",
                          md: "auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_dialog, { width: "500" }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps(props, {
                                  size: "small",
                                  width: "230",
                                  variant: "tonal",
                                  color: "primary",
                                  disabled: !_ctx.selectedUsers.length
                                }), {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      start: "",
                                      icon: "mdi-account-minus"
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.mdAndUp ? 'Remove application user' : 'Remove'), 1)
                                  ]),
                                  _: 2
                                }, 1040, ["disabled"])
                              ]),
                              default: _withCtx(({ isActive }) => [
                                _createVNode(_component_v_card, { width: "500" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Remove user from application")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_card_text, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Are you sure you want to remove this user from this application? The user will no longer have access to the application. ")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_card_actions, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                          onClick: ($event: any) => (isActive.value = false)
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Cancel ")
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        _createVNode(_component_v_btn, {
                                          loading: _ctx.loading,
                                          disabled: _ctx.loading,
                                          color: "primary",
                                          onClick: ($event: any) => {_ctx.removeApplicationUser(_ctx.selectedUsers[0], true); isActive.value = false}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Remove ")
                                          ]),
                                          _: 2
                                        }, 1032, ["loading", "disabled", "onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  style: {"margin-top":"-46px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      "hide-details": "",
                      density: "compact",
                      placeholder: "Search application users",
                      "append-inner-icon": "mdi-magnify",
                      modelValue: _ctx.searchNames,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchNames) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_data_table, {
      items: _ctx.applicationUsers,
      headers: _ctx.headers,
      modelValue: _ctx.selectedUsers,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedUsers) = $event)),
      "fixed-header": "",
      "show-select": "",
      "return-object": "",
      "custom-filter": _ctx.filterUsers,
      search: _ctx.searchNames,
      height: "calc(100vh - 180px)",
      "items-per-page": "25"
    }, {
      [`item.avatar`]: _withCtx(({ item }) => [
        _createVNode(_component_v_avatar, { color: "secondary" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.initials(item.first_name, item.last_name)), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      [`item.full_name`]: _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_ctx.fullName(item.first_name, item.last_name)), 1)
      ]),
      [`item.status`]: _withCtx(({ item }) => [
        (item.status === 'active')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_v_icon, {
                start: "",
                icon: "mdi-circle",
                color: "success"
              }),
              _createTextVNode(" Active ")
            ]))
          : _createCommentVNode("", true),
        (item.status === 'pending')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_v_icon, {
                start: "",
                icon: "mdi-circle",
                color: "grey"
              }),
              _createTextVNode(" Pending ")
            ]))
          : _createCommentVNode("", true)
      ]),
      [`item.applications`]: _withCtx(({item}) => [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getHybridAppsForUser(item), (app) => {
            return (_openBlock(), _createBlock(_component_v_tooltip, {
              key: app.id,
              text: _ctx.currentApplication?.details?.applications.find((a) => a.applicationId === app.id).tabName || app.name,
              location: "bottom",
              "open-delay": "200"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_avatar, _mergeProps(props, {
                  size: "32",
                  color: "secondary",
                  rounded: "",
                  class: "mx-1"
                }), {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.currentApplication?.details?.applications.find((a) => a.applicationId === app.id).tabName.charAt(0) || app.name.charAt(0)), 1)
                  ]),
                  _: 2
                }, 1040)
              ]),
              _: 2
            }, 1032, ["text"]))
          }), 128))
        ])
      ]),
      [`item.actions`]: _withCtx(({ item }) => [
        _createVNode(_component_v_btn, {
          size: "small",
          variant: "tonal",
          color: "primary",
          width: "80",
          onClick: ($event: any) => {_ctx.currentUser = {...item}; _ctx.mapConfig(_ctx.currentApplication); _ctx.editDialog = true;}
        }, {
          default: _withCtx(() => [
            _createTextVNode("Edit")
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 2
    }, 1032, ["items", "headers", "modelValue", "custom-filter", "search"]),
    _createVNode(_component_v_dialog, {
      width: "500",
      modelValue: _ctx.editDialog,
      "onUpdate:modelValue": [
        _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editDialog) = $event)),
        _cache[10] || (_cache[10] = ($event: any) => {_ctx.appConfigDirtied = false;})
      ],
      id: "edit-dialog"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { title: "Edit user" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationsForHybrid, (app) => {
                      return (_openBlock(), _createBlock(_component_v_col, {
                        cols: "12",
                        key: app.id
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, {
                            "no-gutters": "",
                            justify: "space-between",
                            align: "center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.currentApplication?.details?.applications?.find((a) => a.applicationId === app.id)?.tabName || app.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Enabled for this user")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, { cols: "2" }, {
                                default: _withCtx(() => [
                                  app
                                    ? (_openBlock(), _createBlock(_component_v_switch, {
                                        key: 0,
                                        "hide-details": "",
                                        density: "compact",
                                        modelValue: app.enabled,
                                        "onUpdate:modelValue": [
                                          ($event: any) => ((app.enabled) = $event),
                                          _cache[6] || (_cache[6] = ($event: any) => (_ctx.appConfigDirtied = true))
                                        ],
                                        color: "primary"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    (_ctx.applicationAttributes.length)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "12"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11,
                            _createVNode(_component_v_row, { class: "ml-2" }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationAttributes, (attribute) => {
                                  return (_openBlock(), _createBlock(_component_v_col, {
                                    cols: "12",
                                    key: attribute.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, {
                                        "no-gutters": "",
                                        justify: "space-between"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(attribute.name), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_list_item_subtitle, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(attribute.description), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, { cols: "2" }, {
                                            default: _withCtx(() => [
                                              (attribute.type === 'boolean')
                                                ? (_openBlock(), _createBlock(_component_v_switch, {
                                                    key: 0,
                                                    "hide-details": "",
                                                    density: "compact",
                                                    modelValue: _ctx.attributes[attribute.id],
                                                    "onUpdate:modelValue": [
                                                      ($event: any) => ((_ctx.attributes[attribute.id]) = $event),
                                                      _cache[7] || (_cache[7] = ($event: any) => (_ctx.appConfigDirtied = true))
                                                    ],
                                                    color: "primary"
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  loading: _ctx.loading,
                  disabled: _ctx.loading || !_ctx.hasRoleAssigned() || !_ctx.appConfigDirtied,
                  color: "primary",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.saveUser(); _ctx.appConfigDirtied = false;})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Save user ")
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}